// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__e8rvE","unreadBadge":"styles_unreadBadge__mB_I7","modalContent":"styles_modalContent__QddZ3","modal":"styles_modal__2hqnb"};